import React, { useEffect, useState } from 'react';
import { api, formatApiError } from '../lib/api';
import { Check, Info } from 'lucide-react';

const EMPTY = {
    whatsapp: '',
    tripadvisor_url: '',
    google_maps_url: '',
    wifi_name: '',
    wifi_password: '',
    reservation_url: '',
    address: '',
    facebook_url: '',
    instagram_url: '',
    tiktok_url: '',
};

export function RestaurantClientInfoSettings() {
    const [form, setForm] = useState(EMPTY);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        api.get('/r/restaurant/settings')
            .then((r) => {
                const ci = r.data.client_info || {};
                setForm({
                    whatsapp: ci.whatsapp || '',
                    tripadvisor_url: ci.tripadvisor_url || '',
                    google_maps_url: ci.google_maps_url || '',
                    wifi_name: ci.wifi_name || '',
                    wifi_password: ci.wifi_password || '',
                    reservation_url: ci.reservation_url || '',
                    address: ci.address || '',
                    facebook_url: ci.facebook_url || '',
                    instagram_url: ci.instagram_url || '',
                    tiktok_url: ci.tiktok_url || '',
                });
            })
            .catch(() => {});
    }, []);

    const set = (key, val) => {
        setForm((prev) => ({ ...prev, [key]: val }));
        setSaved(false);
    };

    const save = async () => {
        setSaving(true);
        setSaved(false);
        try {
            const { data } = await api.patch('/r/restaurant/client-info', form);
            setForm({ ...EMPTY, ...(data.client_info || {}), address: data.client_info?.address || form.address });
            setSaved(true);
        } catch (e) {
            alert(formatApiError(e));
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="panel" style={{ maxWidth: 640, marginBottom: '2rem' }} data-testid="client-info-settings">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '0.6rem' }}>
                <Info size={18} color="var(--amber)" />
                <h2 className="headline" style={{ fontSize: '1.35rem', margin: 0 }}>Info meniu QR (Detalii)</h2>
            </div>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginTop: 0, lineHeight: 1.5 }}>
                Apare în butonul „Info” din meniul client — link-uri, program, Wi-Fi, rezervări.
            </p>

            <div style={{ display: 'grid', gap: '0.85rem' }}>
                <Field label="WhatsApp (număr)" value={form.whatsapp} onChange={(v) => set('whatsapp', v)} placeholder="07xx xxx xxx" testId="client-info-whatsapp-input" />
                <Field label="TripAdvisor URL" value={form.tripadvisor_url} onChange={(v) => set('tripadvisor_url', v)} placeholder="https://tripadvisor.com/..." testId="client-info-tripadvisor-input" />
                <Field label="Google Maps URL" value={form.google_maps_url} onChange={(v) => set('google_maps_url', v)} placeholder="https://maps.google.com/..." testId="client-info-maps-input" />
                <Field label="Link rezervări" value={form.reservation_url} onChange={(v) => set('reservation_url', v)} placeholder="https://..." testId="client-info-reservation-input" />
                <div style={{ marginTop: '0.25rem' }}>
                    <div className="label" style={{ marginBottom: '0.55rem' }}>Rețele sociale</div>
                    <div style={{ display: 'grid', gap: '0.85rem' }}>
                        <Field label="Facebook" value={form.facebook_url} onChange={(v) => set('facebook_url', v)} placeholder="https://facebook.com/..." testId="client-info-facebook-input" />
                        <Field label="Instagram" value={form.instagram_url} onChange={(v) => set('instagram_url', v)} placeholder="https://instagram.com/..." testId="client-info-instagram-input" />
                        <Field label="TikTok" value={form.tiktok_url} onChange={(v) => set('tiktok_url', v)} placeholder="https://tiktok.com/@..." testId="client-info-tiktok-input" />
                    </div>
                </div>
                <Field label="Adresă (afișată clienților)" value={form.address} onChange={(v) => set('address', v)} placeholder="Str. Exemplu 1, București" testId="client-info-address-input" />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.85rem' }}>
                    <Field
                        label="Rețea wireless"
                        value={form.wifi_name}
                        onChange={(v) => set('wifi_name', v)}
                        placeholder="Introdu rețeaua wireless"
                        testId="client-info-wifi-name"
                    />
                    <Field
                        label="Parolă wireless"
                        value={form.wifi_password}
                        onChange={(v) => set('wifi_password', v)}
                        placeholder="Introdu parola wireless"
                        testId="client-info-wifi-pass"
                    />
                </div>
            </div>

            <button className="btn btn-primary" style={{ marginTop: '1rem' }} onClick={save} disabled={saving} data-testid="client-info-save">
                {saving ? <span className="spinner" /> : <Check size={16} />}
                {saved ? 'Salvat' : 'Salvează info client'}
            </button>
        </div>
    );
}

function Field({ label, value, onChange, placeholder, testId }) {
    return (
        <div>
            <label className="label">{label}</label>
            <input className="input" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} />
        </div>
    );
}
